import { SequenceNodeAction, SequenceNodeType } from "@/@types/flows/sequences";
import { CreateNodeDto } from "@/@types/flows/sequences/dto";
import { NodeTitleByType, NodeAbreviationByType } from "@/app/flows/sequences/utils/texts";
import { SequenceType } from "../enums";

export const timeIntervalBody = (sequenceType: SequenceType): CreateNodeDto => ({
  action:
    sequenceType == SequenceType.AutomaticProgressive
      ? SequenceNodeAction.MakeAutomaticCall
      : SequenceNodeAction.Finish,
  type: SequenceNodeType.TimeInterval,
  title: NodeTitleByType[SequenceNodeType.TimeInterval],
  alias: NodeAbreviationByType[SequenceNodeType.TimeInterval],
  waiting_time: "",
  node_order: 1,
});

export const automaticCallBody = (): CreateNodeDto => ({
  action: SequenceNodeAction.Finish,
  type: SequenceNodeType.AutomaticCall,
  title: NodeTitleByType[SequenceNodeType.AutomaticCall],
  alias: NodeAbreviationByType[SequenceNodeType.AutomaticCall],
  node_order: 1,
});

export const emailBody = (): CreateNodeDto => ({
  action: SequenceNodeAction.Finish,
  type: SequenceNodeType.Email,
  title: NodeTitleByType[SequenceNodeType.Email],
  alias: NodeAbreviationByType[SequenceNodeType.Email],
  node_order: 1,
});

export const whatsappBody = (): CreateNodeDto => ({
  action: SequenceNodeAction.Finish,
  type: SequenceNodeType.Whatsapp,
  title: NodeTitleByType[SequenceNodeType.Whatsapp],
  alias: NodeAbreviationByType[SequenceNodeType.Whatsapp],
  node_order: 1,
});

export const smsBody = (): CreateNodeDto => ({
  action: SequenceNodeAction.Finish,
  type: SequenceNodeType.Sms,
  title: NodeTitleByType[SequenceNodeType.Sms],
  alias: NodeAbreviationByType[SequenceNodeType.Sms],
  node_order: 1,
});
